const scriptData = JSON.parse(document.currentScript.getAttribute("data-json"));
let cartId = document.querySelector("#cart-id") || false;
document.addEventListener("cart:change", (event) =>{
  fetch(window.Shopify.routes.root + "?sections=cart-drawer")
  .then(res => res.json())
  .then(function(data){
    const tmpl = document.createElement('template');
    tmpl.innerHTML = data["cart-drawer"]
    const recElm = tmpl.content.querySelector(".cart-drawer__recommendations");
    if (scriptData.dynamic) {
      recElm.data = JSON.parse(recElm.querySelector("#comp-prod-json").textContent);
      recElm.id = event.detail.cart.items[0].product_id;
      dynamicRecommendations(recElm.data, recElm.id);
    } else {
      document.querySelectorAll(".cart-drawer__recommendations").forEach((e) => {
        e.querySelector("button[aria-label='Previous']").disabled = true;
        e.querySelector("button[aria-label='Next']").disabled = false;
        e.innerHTML = recElm.innerHTML;
      }) 
    }
  })
});

if (scriptData.dynamic && cartId) {
  document.addEventListener('DOMContentLoaded', function () {
    dynamicRecommendations(JSON.parse(document.querySelector("#comp-prod-json").textContent), JSON.parse(document.querySelector("#cart-id").textContent).id);
  });
}

function dynamicRecommendations(compData, id) {
  let cartDrawerRec = document.querySelector(".cart-drawer__recommendations");
  let url = `/recommendations/products.json?product_id=${id}&limit=4`,
      recHtml="",
      currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  fetch(url).then(response => {
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }
    return response.json();
  }).then(data => {
    let products = data.products.reverse();
    var i = products.length; 
    var x = compData.length;
    let product;
    while (x--) {
      product = compData[x]
        recHtml +=`
        <div class="vertical-product rounded-xs snap-start bg-custom" style="${scriptData.vpStyle}">
          <img src="${product.featured_image}" alt="${product.title}" width="1000" height="1000" loading="eager"  class="vertical-product__image rounded-xs">
          <div class="vertical-product__info">
            <div class="v-stack gap-0.5">
              <a href="${window.Shopify.routes.root}/products/${product.handle}" data-instant="" class="vertical-product-title">${product.title}</a>
              <p class="vertical-product-price">
                <price-list class="price-list  ">
                  <sale-price class="text-subdued">
                    <span class="sr-only">Sale price</span>${formatMoney(product.variants[0].price, currencyFormat)}
                  </sale-price>
                  <compare-at-price `
                    if (product.variants[0].price >= product.variants[0].compare_at_price){
                      recHtml += `hidden`  
                    }
                   recHtml += ` class="text-subdued line-through">
                    <span class="sr-only">Regular price</span>${formatMoney(product.variants[0].compare_at_price, currencyFormat)}
                  </compare-at-price>
                </price-list>
              </p>
            </div>
          `
          if (product.variants != undefined && product.variants.length > 1){
            recHtml +=` <div class="vertical-product__cta">
              <button type="button" class="button button--sm button--secondary" aria-controls="quick-buy-vertical-comp-${x}-${product.id}" aria-expanded="false" is="custom-button">
                <div>+ Add</div>
                <span class="button__loader">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <quick-buy-drawer id="quick-buy-vertical-comp-${x}-${product.id}" header-bordered="" open-from="bottom" handle="${product.handle}" role="dialog" aria-live="polite" class="quick-buy-drawer drawer" aria-modal="true"></quick-buy-drawer>
            </div> `
          } else {
                recHtml +=`<div class="vertical-product__cta">
                  <form method="post" action="/cart/add" id="complementary-product-comp-${x}-${product.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="quantity" value="1">
                    <input type="hidden" name="id" value="${product.variants[0].id}">
                    <button type="submit" class="button button--sm button--secondary" is="custom-button">
                      <div>+ Add</div>
                      <span class="button__loader">
                        <span></span>
                        <span></span>
                        <span></span>
                      </span>
                    </button>
                  </form>
                </div>
              </div>`
          } 
        recHtml +=` 
            </div>
          </div>
        `
    }
    while (i--) {
      product = products[i];
      recHtml += `
        <div class="vertical-product rounded-xs snap-start bg-custom" style="${scriptData.vpStyle}">
          <img src="${product.featured_image}" alt="${product.title}" width="1000" height="1000" loading="eager"  class="vertical-product__image rounded-xs">
          <div class="vertical-product__info">
            <div class="v-stack gap-0.5">
              <a href="${product.url}" data-instant="" class="vertical-product-title">${product.title}</a>
              <p class="vertical-product-price">
                <price-list class="price-list  ">
                  <sale-price class="text-subdued">
                    <span class="sr-only">Sale price</span>${formatMoney(product.variants[0].price, currencyFormat)}
                  </sale-price>
                  <compare-at-price `
                  if (product.variants[0].price >= product.variants[0].compare_at_price){
                    recHtml += `hidden`  
                  }
                  recHtml += ` class="text-subdued line-through">
                    <span class="sr-only">Regular price</span>${formatMoney(product.variants[0].compare_at_price, currencyFormat)}
                  </compare-at-price>
                </price-list>
              </p>
            </div>
      `
      if (product.variants != undefined && product.variants.length > 1){
        recHtml +=`
          <div class="vertical-product__cta">
            <button type="button" class="button button--sm button--secondary" aria-controls="quick-buy-vertical-${i}-${product.id}" aria-expanded="false" is="custom-button">
              <div>+ Add</div>
              <span class="button__loader">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <quick-buy-drawer id="quick-buy-vertical-${i}-${product.id}" header-bordered="" open-from="bottom" handle="${product.handle}" role="dialog" aria-live="polite" class="quick-buy-drawer drawer" aria-modal="true"></quick-buy-drawer>
          </div>
        `
      } else {
        recHtml += `
              <div class="vertical-product__cta">
                <form method="post" action="/cart/add" id="complementary-product-${i}-${product.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="quantity" value="1">
                  <input type="hidden" name="id" value="${product.variants[0].id}">
                  <button type="submit" class="button button--sm button--secondary" is="custom-button">
                    <div>+ Add</div>
                    <span class="button__loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </button>
                </form>
              </div>
            </div>
        `
      }
      recHtml += `    
          </div>
        </div>
      `
    }
    cartDrawerRec.querySelector("#cart-drawer-recommendations .vertical-product-list").innerHTML = recHtml;
    cartDrawerRec.querySelector("button[aria-label='Previous']").disabled = true;
    cartDrawerRec.querySelector("button[aria-label='Next']").disabled = false;
    document.querySelector(".cart-drawer__recommendations").innerHTML = cartDrawerRec.innerHTML;

  }).catch(error => {
    console.error('Fetch error:', error);
  });
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
